addEventListener("storage", (event) => { 
    if (event.key === 'delivery-date' || event.key === 'delivery-ship-type') {
        if(event.newValue !== event.oldValue) {
            location.reload();
        }
    }
});
